
import React from 'react'
import {Row, Col} from 'antd'
import UserDevices from '@components/public-users/item/UserDevices';
import AccessTokens from '@components/public-users/item/AccessTokens';
import UserLastLogin from '@components/public-users/item/UserLastLogin';

interface Props {
  userId : string
}


const Index = (props: Props) => {
  return(
    <div>
      <Row gutter={24}>
        <Col span={12}>
          <AccessTokens {...props}/>
        </Col>
        <Col span={12}>
          <UserLastLogin {...props}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <UserDevices {...props}/>
        </Col>
      </Row>
    </div>
  )
};
export default Index;